module.exports = __webpack_public_path__ + "img/15vsSKY.356fd1e4.png";